module.exports = __webpack_public_path__ + "static/media/big-cham.f5c17d49.mp3";